export default "__VITE_ASSET__8ce65ed1__"